import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "https://dot.mavxnetworks.com",
    headers: {
        "x-app-id": "Admin",
        "x-app-version": "1.0.0",
        "x-user-agent": "Web",
        "Content-Type": "application/json"
    }
});

const AUTH_TOKEN_KEY = "dot_auth_token";
const USER_KEY = "dot_user";

export const setSession = ({ auth_token, user }) => {
    if (auth_token) sessionStorage.setItem(AUTH_TOKEN_KEY, auth_token);
    if (user) sessionStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getAuthToken = () => sessionStorage.getItem(AUTH_TOKEN_KEY);

export const getUser = () => {
    try {
        return JSON.parse(sessionStorage.getItem(USER_KEY));
    } catch {
        return null;
    }
};

export const clearSession = () => {
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
};

API.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) config.headers["x-access-token"] = token;
    return config;
});

API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && getAuthToken()) {
            clearSession();
            window.location.replace("/");
        }
        return Promise.reject(error);
    }
);

export const errorMessage = (err, fallback = "Something went wrong") =>
    err?.response?.data?.message || err?.message || fallback;

export const login = ({ username, password, captcha_token }) =>
    API.post("/api/v1/auth/login", { username, password, captcha_token });

export const listAnnexure = (type) => API.get(`/api/v1/annexure/${type}`);

